export default "__VITE_ASSET__E8hWNRIP__"